import { useState } from 'react'
import { Collapse, Paper, Stack, Text, Title, UnstyledButton } from '@mantine/core'
import { IconChevronUp } from '@tabler/icons-react'
import classes from '../../styles/StudioEditorV2.module.css'

/**
 * The card every left-column block is built from.
 *
 * `collapsible` and `defaultOpen` are optional additions for the redesigned editor;
 * called without them this renders the same static card TemplateReviewPage relies on.
 */
export function SectionCard({
  title,
  description,
  children,
  action,
  className,
  collapsible = false,
  defaultOpen = true,
}) {
  const [open, setOpen] = useState(defaultOpen)

  const heading = (
    <div className={classes.cardHeadingRow}>
      <div>
        <Title order={3} className={classes.cardTitle}>
          {title}
        </Title>
        {description && (
          <Text size="xs" c="dimmed" mt={3}>
            {description}
          </Text>
        )}
      </div>
      {action}
      {collapsible && (
        <IconChevronUp
          size={20}
          className={classes.cardChevron}
          data-open={open ? 'true' : 'false'}
          aria-hidden="true"
        />
      )}
    </div>
  )

  return (
    <Paper withBorder radius="lg" className={[classes.card, className].filter(Boolean).join(' ')}>
      <Stack gap="md">
        {collapsible ? (
          <UnstyledButton
            onClick={() => setOpen((value) => !value)}
            aria-expanded={open}
            className={classes.cardHeadingButton}
          >
            {heading}
          </UnstyledButton>
        ) : (
          heading
        )}

        {collapsible ? <Collapse in={open}>{children}</Collapse> : children}
      </Stack>
    </Paper>
  )
}
